var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#BD9A31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3496 19.7998H16.6496C14.4127 19.7998 12.5996 21.6129 12.5996 23.8498C12.5996 23.8498 14.6246 24.7498 17.9996 24.7498C21.3746 24.7498 23.3996 23.8498 23.3996 23.8498C23.3996 21.6129 21.5866 19.7998 19.3496 19.7998Z",
    stroke: "white",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8496 14.4C14.8496 12.6603 16.2599 11.25 17.9996 11.25C19.7393 11.25 21.1496 12.6603 21.1496 14.4C21.1496 16.1397 19.7393 18 17.9996 18C16.2599 18 14.8496 16.1397 14.8496 14.4Z",
    stroke: "white",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar22);
export default __webpack_public_path__ + "static/media/avatar-22.db7a83d19af85817d35556116772f703.svg";
export { ForwardRef as ReactComponent };